import { authRoles } from "../../../auth/authRoles";
import EditLaporanTahunan from "./EditLaporanTahunan";
import LaporanTahunan from "./LaporanTahunan";
import TambahLaporanTahunan from "./TambahLaporanTahunan";

const laporanTahunanRoute = [
  {
    path: "/laporan_tahunan/edit/:id",
    exact: true,
    component: EditLaporanTahunan,
    auth: authRoles.all,
  },
  {
    path: "/laporan_tahunan/tambah",
    exact: true,
    component: TambahLaporanTahunan,
    auth: authRoles.all,
  },
  {
    path: "/laporan_tahunan",
    exact: true,
    component: LaporanTahunan,
    auth: authRoles.all,
  },
];

export default laporanTahunanRoute;
